import { render, staticRenderFns } from "./passengerItem.vue?vue&type=template&id=0512bb9b&"
import script from "./passengerItem.vue?vue&type=script&lang=js&"
export * from "./passengerItem.vue?vue&type=script&lang=js&"
import style0 from "./passengerItem.vue?vue&type=style&index=0&id=0512bb9b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports